import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledPresetBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
`;

export const StyledPresetButton = styled.button<{ $active?: boolean }>`
  border: 1px solid ${({ $active }) => ($active ? COLORS.YELLOW_PRIMARY : COLORS.BRIGHT_GRAY)};
  background: ${COLORS.WHITE};
  border-radius: 0.5rem;
  padding: 0.5rem 0.875rem;
  cursor: pointer;
  ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
  color: ${COLORS.BLACK};
  white-space: nowrap;
  box-shadow: ${({ $active }) => ($active ? `0 0 0 1px ${COLORS.YELLOW_PRIMARY}` : 'none')};

  &:hover {
    border-color: ${COLORS.YELLOW_PRIMARY};
  }
`;

export const StyledPresetLabel = styled.div`
  ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
  color: ${COLORS.BLACK};
`;

export const StyledPresetValue = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
`;

export const StyledCustomPreset = styled.div<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid ${({ $active }) => ($active ? COLORS.YELLOW_PRIMARY : COLORS.BRIGHT_GRAY)};
  background: ${COLORS.WHITE};
  border-radius: 0.5rem;
  padding: 0 0.5rem 0 0.875rem;
  min-width: 16rem;
  box-shadow: ${({ $active }) => ($active ? `0 0 0 1px ${COLORS.YELLOW_PRIMARY}` : 'none')};

  ${StyledPresetLabel} {
    ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
    color: ${COLORS.BLACK};
    white-space: nowrap;
  }

  .ant-picker {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 0 !important;
    height: 35.6px !important;
    min-height: 35.6px !important;
  }

  .ant-picker input {
    ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
    color: ${COLORS.BLACK};
  }

  @media screen and ${DEVICES.LAPTOP_S} {
    min-width: 18rem;
  }
`;
